<template>
  <footer class="max-w-4xl mx-auto py-6">
    <div
      class="flex flex-col text-center sm:text-left sm:flex-row sm:justify-around"
    >
      <div class="self-center">
        <a class="" href="#top">
          <Picture
            imgClass="h-40"
            src="img/schlosserei-raichle-logo-slogan.png"
            alt="Schlosserei Raichle Logo"
          />
        </a>
      </div>

      <div class="mt-4 sm:mt-0">
        <h2 id="kontakt" class="font-bold uppercase mb-2 font-brand text-sm">Kontakt</h2>
        <address>
          Kelterstraße 47<br />
          73265 Dettingen unter Teck
        </address>
        <div class="mt-4 text-brand-blue font-semibold">
          Telefon: <a href="tel:00490702181516">07021 / 81516</a><br />
          Fax: 07021 / 82050<br />
          <a href="mailto:info@schlosserei-raichle.de"
            >info@schlosserei-raichle.de</a
          >
        </div>
      </div>

      <div class="mt-4 sm:mt-0">
        <h2 id="kontakt" class="font-bold uppercase mb-2 font-brand text-sm">Rechtliches</h2>
        <a class="block" href="datenschutz.html">Datenschutz</a>
        <a class="block" href="impressum.html">Impressum</a>
      </div>
    </div>
  </footer>
</template>

<script>
import Picture from "../components/Picture.vue";

export default {
    name: "Footer",
    components: {
      Picture,
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
